import { render, staticRenderFns } from "./StagingInternalDiversion2Page.vue?vue&type=template&id=73287964&scoped=true&"
import script from "./StagingInternalDiversion2Page.vue?vue&type=script&lang=js&"
export * from "./StagingInternalDiversion2Page.vue?vue&type=script&lang=js&"
import style0 from "./StagingInternalDiversion2Page.vue?vue&type=style&index=0&id=73287964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73287964",
  null
  
)

export default component.exports